import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, Snackbar, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export const useHasActiveAccess = () => {
    const { user, isAuthenticated } = useAuth();
    if (!isAuthenticated || !user) return false;
    return (
        user.hasActiveSubscription ||
        user.subscription?.status === 'active' ||
        user.subscription?.status === 'trialing' ||
        user.role === 'admin'
    );
};

export const SubscriberCtaContent = ({
    title = 'Know someone who wants to read faster?',
    description = 'Share your affiliate link and earn $3.00/month for every referral subscription. Two-level rewards mean you also earn when your referrals bring in others.',
    primaryLabel = 'Copy My Affiliate Link',
    secondaryLabel = 'View Affiliate Dashboard',
    secondaryPath = '/affiliate',
    align = 'center',
}) => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [copied, setCopied] = useState(false);

    const affiliateLink = user
        ? `${window.location.origin}?ref=${user.username}`
        : '';

    const handleCopy = () => {
        if (affiliateLink) {
            navigator.clipboard.writeText(affiliateLink);
            setCopied(true);
            setTimeout(() => setCopied(false), 2500);
        }
    };

    return (
        <>
            <Typography
                variant="h4"
                sx={{ fontWeight: 700, color: 'text.primary', mb: 1, textAlign: align }}
            >
                {title}
            </Typography>
            <Typography
                variant="body1"
                sx={{ color: 'text.secondary', mb: 3, maxWidth: 520, mx: 'auto', textAlign: align }}
            >
                {description}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap', alignItems: 'center' }}>
                <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    onClick={handleCopy}
                    startIcon={<ContentCopyIcon />}
                    sx={{ py: 1.5, px: 5 }}
                >
                    {primaryLabel}
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    size="large"
                    onClick={() => navigate(secondaryPath)}
                    sx={{ py: 1.5, px: 5 }}
                >
                    {secondaryLabel}
                </Button>
            </Box>
            <Snackbar
                open={copied}
                autoHideDuration={2500}
                onClose={() => setCopied(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity="success" onClose={() => setCopied(false)} sx={{ width: '100%' }}>
                    Affiliate link copied to clipboard!
                </Alert>
            </Snackbar>
        </>
    );
};

export default SubscriberCtaContent;
